/*
 * Carlyle Avenue cart-page status announcer
 * ---------------------------------------------------------------------------
 * The estimated-total node already carries role="status", but it lives INSIDE
 * the morphing cart-items region — Idiomorph patches it in place on every cart
 * update, so screen readers don't reliably announce the new subtotal when a
 * shopper changes a line quantity or removes a line. This adds a persistent
 * visually-hidden live region OUTSIDE the morph and announces into it on
 * `cart:update`, so quantity/removal changes are spoken.
 *
 * Vanilla JS, no dependencies. IIFE + page-level init guard. Additive only —
 * same convention as ca-stock.js / ca-search-a11y.js; it never owns or forks
 * cart state, it just mirrors the post-morph subtotal to an aria-live region.
 */
(function () {
  if (window.__caCartLiveInit) return;
  window.__caCartLiveInit = true;

  var region = document.querySelector('[data-cart-live]');
  if (!region) return;

  var last = '';

  function announce() {
    // Read the post-morph subtotal from the totals node (rendered by cart-summary.liquid).
    var totalEl = document.querySelector('[data-cart-subtotal]');
    var total = totalEl ? totalEl.textContent.replace(/\s+/g, ' ').trim() : '';
    var message = total ? 'Cart updated. Estimated total ' + total : 'Cart updated.';
    // Skip if nothing meaningful changed (avoids re-announcing identical totals).
    if (message === last) return;
    last = message;
    // Clear first so consecutive identical-then-changed updates still re-trigger the region.
    region.textContent = '';
    region.textContent = message;
  }

  document.addEventListener('cart:update', function () {
    // Let the cart-items morph land before reading the subtotal (mirrors the small settle
    // delay cart-upsell.js uses for its own refill).
    clearTimeout(window.__caCartLiveTimer);
    window.__caCartLiveTimer = setTimeout(announce, 300);
  });
})();
